/* ===== iron-quickview (PREVIEW 139512316113) — mejoras al Quick View de Boost =====
   - Insignias: "Agotado", "Hasta X%" (misma lógica ieliq-* que las tarjetas), "Oferta".
   - Agotado: botón "Cotizar por WhatsApp" con texto prellenado + "Ver todos los detalles" como botón.
   - Variantes agotadas tachadas, textos en español, aria-label "Cerrar".
   No reemplaza el flujo de Boost (agregar al carrito / cerrar con Esc o fondo siguen siendo de Boost).
   Para revertir: quitar las 2 líneas iron-quickview en layout/theme.liquid. */
(function () {
  if (window.__ironQV) return;
  window.__ironQV = true;
  var WA = '524761358111';
  var LEVELS = [35, 25, 15, 10];
  var cache = {};
  /* Gate promo: "Hasta X%" (ieliq-*) no se muestra antes del lanzamiento 2026-10-05 00:00 America/Mexico_City (UTC-6 = 06:00 UTC).
     Se activa sola en esa fecha; para lanzarla antes/después cambiar IELIQ_FROM. */
  var IELIQ_FROM = Date.UTC(2026, 9, 5, 6, 0, 0);
  function ieliqLive() { return Date.now() >= IELIQ_FROM; }
  var WA_ICON = '<svg viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" d="M16.04 3C8.86 3 3.03 8.82 3.03 16c0 2.3.6 4.53 1.74 6.5L3 29l6.68-1.75A12.94 12.94 0 0 0 16.04 29C23.2 29 29 23.18 29 16S23.2 3 16.04 3zm0 23.8c-1.98 0-3.9-.53-5.6-1.53l-.4-.24-3.96 1.04 1.06-3.86-.26-.4A10.76 10.76 0 0 1 5.24 16c0-5.95 4.84-10.8 10.8-10.8 5.95 0 10.78 4.85 10.78 10.8 0 5.96-4.83 10.8-10.78 10.8zm5.92-8.08c-.32-.16-1.92-.95-2.22-1.06-.3-.11-.51-.16-.73.16-.21.32-.84 1.06-1.03 1.27-.19.22-.38.24-.7.08-.32-.16-1.37-.5-2.6-1.6-.96-.86-1.6-1.91-1.8-2.23-.18-.32-.02-.5.15-.66.14-.14.32-.38.48-.56.16-.19.21-.32.32-.54.1-.21.05-.4-.03-.56-.08-.16-.72-1.74-.99-2.38-.26-.62-.53-.54-.73-.55h-.62c-.21 0-.56.08-.86.4-.29.32-1.12 1.1-1.12 2.68s1.15 3.1 1.31 3.32c.16.21 2.26 3.45 5.47 4.84.77.33 1.36.53 1.83.67.77.25 1.47.21 2.02.13.62-.09 1.92-.78 2.19-1.54.27-.75.27-1.4.19-1.54-.08-.13-.29-.21-.61-.37z"/></svg>';

  function ieliqMax(tags) {
    if (!tags) return 0;
    if (typeof tags === 'string') tags = tags.split(',');
    var set = {};
    for (var i = 0; i < tags.length; i++) set[String(tags[i]).trim().toLowerCase()] = 1;
    for (var j = 0; j < LEVELS.length; j++) if (set['ieliq-' + LEVELS[j]]) return LEVELS[j];
    return 0;
  }
  function handleOf(qv) {
    var a = qv.querySelector('.boost-sd__quick-view-details-link');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function getProduct(h) {
    if (!cache[h]) {
      cache[h] = { p: null, promise: fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { cache[h].p = p; schedule(); return p; })
        .catch(function () { return null; }) };
    }
    return cache[h].p;
  }
  function selectedValues(qv) {
    var out = [];
    qv.querySelectorAll('.boost-sd__product-swatch').forEach(function (sw) {
      var i = sw.querySelector('input:checked') || sw.querySelector('.boost-sd__product-swatch-option--selected input');
      out.push(i ? i.value : null);
    });
    return out;
  }
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function currentVariant(p, vals) {
    if (!p || !p.variants) return null;
    if (!vals.length) return p.variants[0];
    for (var k = 0; k < p.variants.length; k++) {
      var v = p.variants[k], ok = true;
      for (var i = 0; i < vals.length; i++) if (vals[i] != null && norm(v.options[i]) !== norm(vals[i])) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function setText(el, txt) {
    /* cambia el nodo de texto existente (no lo reemplaza) para no romper el render de Boost */
    if (!el) return;
    var n = el.firstChild;
    if (n && n.nodeType === 3) { if (n.nodeValue !== txt) n.nodeValue = txt; }
    else if (!el.children.length && el.textContent !== txt) el.textContent = txt;
  }
  function cap(s) { s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function ensure(parent, cls, before, tag) {
    var el = parent.querySelector(':scope > .' + cls);
    if (!el) {
      el = document.createElement(tag || 'div');
      el.className = cls;
      if (before && before.parentNode === parent) parent.insertBefore(el, before); else parent.appendChild(el);
    }
    return el;
  }

  var busy = false;
  function enhance(qv) {
    var info = qv.querySelector('.boost-sd__quick-view-product-info');
    if (!info) return;
    var modal = qv.closest('.boost-sd__modal');
    if (modal && !modal.classList.contains('iron-qv-modal')) modal.classList.add('iron-qv-modal');
    var close = modal && modal.querySelector('.boost-sd__button-text-x--as-close-modal');
    if (close && close.getAttribute('aria-label') !== 'Cerrar') close.setAttribute('aria-label', 'Cerrar');

    var h = handleOf(qv);
    var p = h ? getProduct(h) : null;
    var vals = selectedValues(qv);
    var v = currentVariant(p, vals);
    var btnBox = qv.querySelector('.boost-sd__quick-view-btn');
    var enabled = btnBox ? [].filter.call(btnBox.querySelectorAll('button'), function (b) { return !b.disabled && !/agotado|sold out/i.test(b.textContent); }) : [];
    var soldOut = !!btnBox && !enabled.length;
    qv.classList.toggle('iqv-is-soldout', soldOut);

    /* textos de botones */
    var atcT = qv.querySelector('.boost-sd__btn-add-to-cart .boost-sd__button-text');
    if (atcT && /agregar a carrito|add to cart/i.test(atcT.textContent)) setText(atcT, 'Agregar al carrito');
    var bnT = qv.querySelector('.boost-sd__btn-buy-now .boost-sd__button-text');
    if (bnT && /comprar ahora|buy now/i.test(bnT.textContent) && bnT.textContent !== 'Comprar ahora') setText(bnT, 'Comprar ahora');

    qv.querySelectorAll('.boost-sd__quantity .boost-sd__button-text').forEach(function (t) { if (t.textContent === '-') setText(t, '\u2212'); });

    /* insignias */
    var lvl = (p && ieliqLive()) ? ieliqMax(p.tags) : 0;
    if (!lvl && ieliqLive() && qv.getAttribute('product-id')) {
      var card = document.querySelector('.boost-sd__product-item[data-product-id="' + qv.getAttribute('product-id') + '"] .ieliq-boost-wrap');
      if (card) lvl = parseInt(card.getAttribute('data-ieliq'), 10) || 0;
    }
    var onSale = !!qv.querySelector('.boost-sd__quick-view-price .boost-sd__format-currency--price-compare');
    var html = '';
    if (soldOut) html += '<span class="iqv-badge iqv-badge--soldout">Agotado</span>';
    if (lvl) html += '<span class="iqv-badge iqv-badge--ieliq">Hasta ' + lvl + '%</span>';
    else if (onSale) html += '<span class="iqv-badge iqv-badge--sale">Oferta</span>';
    var badges = ensure(info, 'iqv-badges', info.firstChild);
    if (badges.innerHTML !== html) badges.innerHTML = html;

    /* variantes agotadas */
    if (p && p.variants && p.variants.length > 1) {
      qv.querySelectorAll('.boost-sd__product-swatch').forEach(function (sw, idx) {
        sw.querySelectorAll('.boost-sd__product-swatch-option').forEach(function (opt) {
          var inp = opt.querySelector('input');
          if (!inp) return;
          var test = vals.slice(); test[idx] = inp.value;
          var any = p.variants.some(function (vv) {
            if (!vv.available) return false;
            for (var i = 0; i < test.length; i++) if (test[i] != null && norm(vv.options[i]) !== norm(test[i])) return false;
            return true;
          });
          opt.classList.toggle('iqv-opt-soldout', !any);
          var lab = opt.querySelector('label');
          if (lab) { var t = any ? '' : 'Agotado'; if ((lab.getAttribute('title') || '') !== t) { if (t) lab.setAttribute('title', t); else lab.removeAttribute('title'); } }
        });
      });
    }

    /* bloque agotado + WhatsApp */
    var details = info.querySelector('.boost-sd__quick-view-details-link');
    var block = info.querySelector(':scope > .iqv-soldout');
    if (soldOut) {
      var title = (p && p.title) || ((info.querySelector('.boost-sd__quick-view-title') || {}).textContent || '').trim();
      var vt = v && v.title && v.title !== 'Default Title' ? ' (' + v.title + ')' : '';
      var url = location.origin + '/products/' + (h || '');
      var msg = 'Hola, quiero cotizar el producto ' + title + vt + ' que aparece agotado en la tienda: ' + url;
      var href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg);
      if (!block) {
        block = document.createElement('div');
        block.className = 'iqv-soldout';
        block.innerHTML = '<p class="iqv-soldout__note"><strong>' + (vt ? 'Esta variante está agotada.' : 'Producto agotado.') + '</strong> Cotiza disponibilidad y tiempo de entrega con un asesor.</p>' +
          '<a class="iqv-wa" target="_blank" rel="noopener" href="#">' + WA_ICON + '<span>Cotizar por WhatsApp</span></a>';
        var btns = info.querySelector('.boost-sd__quick-view-btn');
        var ref = (btns && btns.nextSibling) || details;
        if (ref && ref.parentNode === info) info.insertBefore(block, ref); else info.appendChild(block);
      }
      var a = block.querySelector('.iqv-wa');
      if (a.getAttribute('href') !== href) a.setAttribute('href', href);
      var strong = block.querySelector('strong'), st = vt ? 'Esta variante está agotada.' : 'Producto agotado.';
      if (strong && strong.textContent !== st) strong.textContent = st;
    }
    if (details && /ver todos los detalles|view full details/i.test(details.textContent) && details.firstChild && details.firstChild.nodeType === 3 && details.firstChild.nodeValue.trim() !== 'Ver todos los detalles') details.firstChild.nodeValue = 'Ver todos los detalles';
  }

  var queued = false, bound = null, qvObs = null;
  function run() {
    queued = false;
    if (busy) return;
    var qv = document.querySelector('.boost-sd__modal .boost-sd__quick-view');
    document.documentElement.classList.toggle('iqv-open', !!qv);
    if (!qv) { if (qvObs) { qvObs.disconnect(); qvObs = null; bound = null; } return; }
    busy = true;
    try { enhance(qv); } catch (e) { /* no-op */ }
    busy = false;
    if (bound !== qv) {
      if (qvObs) qvObs.disconnect();
      bound = qv;
      qvObs = new MutationObserver(schedule);
      qvObs.observe(qv, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked', 'disabled'], characterData: true });
    }
    if (qvObs) qvObs.takeRecords();
  }
  function schedule() {
    if (busy || queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }
  function start() {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var add = muts[i].addedNodes, rem = muts[i].removedNodes;
        for (var j = 0; j < add.length; j++) if (add[j].nodeType === 1 && (add[j].matches('.boost-sd__modal, .boost-sd__quick-view') || add[j].querySelector('.boost-sd__quick-view'))) return schedule();
        if (bound) for (var k = 0; k < rem.length; k++) if (rem[k].nodeType === 1 && rem[k].contains(bound)) return schedule();
      }
    }).observe(document.body, { childList: true, subtree: true });
    schedule();
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* ===== iron-hide-internal-tags — oculta tags internos en el filtro "Tag" de Boost =====
   ieliq-* (promo), cupones-fin-de-ano, ultimo-round. Si el grupo queda sin opciones visibles, se oculta el grupo completo.
   Re-aplica con MutationObserver (Boost re-renderiza filtros al filtrar/paginar/abrir el drawer móvil). */
(function () {
  if (window.__ironHideTags) return;
  window.__ironHideTags = true;
  var RX = /^\s*(ieliq-[\w-]*|cupones-fin-de-ano|ultimo-round)\s*$/i;
  var ATTR = 'data-iron-hidden';
  function setHidden(el, hide) {
    if (hide === el.hasAttribute(ATTR)) return;
    if (hide) { el.setAttribute(ATTR, ''); el.style.setProperty('display', 'none', 'important'); }
    else { el.removeAttribute(ATTR); el.style.removeProperty('display'); }
  }
  var queued = false;
  function scan() {
    queued = false;
    try {
      document.querySelectorAll('.boost-sd__filter-option-item').forEach(function (li) {
        var l = li.querySelector('.boost-sd__filter-option-item-label');
        setHidden(li, !!l && RX.test(l.textContent || ''));
      });
      document.querySelectorAll('.boost-sd__filter-option').forEach(function (g) {
        var items = g.querySelectorAll('.boost-sd__filter-option-item');
        if (!items.length) { setHidden(g, false); return; }
        var anyVisible = false;
        for (var i = 0; i < items.length; i++) if (!items[i].hasAttribute(ATTR)) { anyVisible = true; break; }
        setHidden(g, !anyVisible);
      });
      /* chips de "filtrado por" (por si llega una URL con el tag aplicado) */
      document.querySelectorAll('[class*="boost-sd__refine-by"][class*="-item"]').forEach(function (c) {
        var t = (c.textContent || '').replace(/^.*?:\s*/, '');
        if (c.children.length < 6) setHidden(c, RX.test(t));
      });
    } catch (e) { /* no-op */ }
  }
  function schedule() { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(scan); } }
  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    scan();
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
